import * as React from 'react';
export const americafirstcuSvg = React.forwardRef(
  function americafirstcuSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#01548E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M18.732 16.908c0-1.56 1.376-2.84 3.032-2.84H27v2.204h-5.236c-.366 0-.663.28-.663.619v1.926c0 1.873-1.62 3.389-3.616 3.389-2.29 0-4.147-1.847-4.147-4.121 0-.331.07-.785.07-.785.122-.88.34-2.352.34-2.352.06-.592 1.629-.226 1.681-.052 0 0 .114-.384.192-1.272.07-.889-.54-1.072-.863-1.072h-3.912L5 20.742v-3.964l3.503-4.906c.512-.781-.426-1.96-.517-2.074L7.98 9.79c.026.017 1.237.715 3.546.697 1.693-.013 2.854-.048 3.467-.066.236-.008.39-.012.462-.012h.007c.299 0 3.021-.003 2.512 2.97-.523 2.998-.724 4.122-.724 4.122-.296-.654-1.132-.627-1.402-.601l-.088.418c-.017.113-.043.322-.043.322a4.92 4.92 0 0 0-.044.453c0 1.055.802 1.917 1.795 1.917.697 0 1.264-.531 1.264-1.185v-1.917Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13.626 13.188h-2.03c1.28.863 1.498.924 1.794.775.244-.121.236-.775.236-.775Zm8.608 4.261h4.748v2.204h-4.748v-2.204Z',
        fill: '#fff',
      }),
    );
  },
);
americafirstcuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var americafirstcu = {
  category: 'brand',
  colorable: false,
  name: 'americafirstcu',
  svg: americafirstcuSvg,
};
